import React, { useEffect } from 'react';
import localeData from 'dayjs/plugin/localeData';
import dayjs from 'dayjs';
import { ToastContainer } from 'react-toastify';
import Routes from './routes';
import MenuProvider from './context/menuHeader';
import PdfDialogProvider from './context/pdfViewerDialog';
import 'react-toastify/dist/ReactToastify.css';
import initializeENotificationsTemplates from './Guidance/components/Pages/Notifications/Data';

import './index.scss';

export const displayName = 'InfoImage';

dayjs.extend(localeData);

export default function App(): React.ReactElement {
  document.title = `${displayName}: Home`;

  useEffect(() => {
    initializeENotificationsTemplates();
  }, []);

  return (
    <>
      <ToastContainer position="top-center" />
      <MenuProvider>
        <PdfDialogProvider>
          <Routes />
        </PdfDialogProvider>
      </MenuProvider>
    </>
  );
}
